angular.module 'zc.projects.reports'

.factory 'clientReportCsvCreator', ($filter, $q, $translate, campaignStatusTexts, CampaignStats, currencies) ->
  applyCurrency = (value, currency) ->
    # Do not show currency symbol or suffix for data row since CSV file headers already include them.
    $filter('zcCurrency')(value, '', currency.fractionSize, '')

  createCsv: (project, campaignsWithStats, isAb) ->
    currency = currencies[project.currency]
    $q (resolve, reject) ->
      csvData = []
      headers = []
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.id'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.suteetasu'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kyanpeen_na'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kyanpeen_tesuuryou_ritsu'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kaishibi'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.shuuryoubi'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.debaisu'))
      if isAb
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.moment_kazu'))
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.ab_hiritsu'))
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.guruupu'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.haishin_kazu'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cv_ritsu'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cv_kazu'))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.heikin_cv_kingaku', {
        currency: currency.symbol || currency.suffix
      }))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.goukei_cv_kingaku', {
        currency: currency.symbol || currency.suffix
      }))
      if project.product_line is 'zenclerk_lp'
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cpa_kingaku', {
          currency: currency.symbol || currency.suffix
        }))
      if isAb
        if project.product_line is 'zenclerk_lp'
          headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kakutoku_cv_kazu'))
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.cv_joushouritsu'))
        headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.kakutoku_kingaku', {
          currency: currency.symbol || currency.suffix
        }))
      headers.push($translate.instant('projectsReports.services.clientReportCsvCreator.zc_kosuto', {
        currency: currency.symbol || currency.suffix
      }))
      csvData.push headers

      for campaign in campaignsWithStats
        if campaign.stats
          stat = campaign.stats
        else
          stat =
            experimental:
              delivery_count: 0
              conversion_rate: 0
              conversion_count: 0
              average_conversion_price: 0
              conversion_price: 0
            control:
              delivery_count: 0
              conversion_rate: 0
              conversion_count: 0
              average_conversion_price: 0
              conversion_price: 0

        dateFilter = $filter('date')

        device = switch campaign.campaign_device
          when 'pc' then 'PC/iPad'
          when 'sp' then 'sp'
          when 'iphone' then 'iPhone'
          else ''

        total_delivery_count = (stat.control.delivery_count + stat.experimental.delivery_count)
        expRecord = []
        expRecord.push(campaign.id)
        expRecord.push(campaignStatusTexts[campaign.current_status])
        expRecord.push(campaign.name)
        expRecord.push(campaign.fee_rate || CampaignStats.ZC_COST_RATE)
        expRecord.push("#{dateFilter(campaign.start_at.valueOf(), 'yyyy/MM/dd')}")
        expRecord.push("#{dateFilter(campaign.end_at.valueOf(), 'yyyy/MM/dd')}")
        expRecord.push(device)
        if isAb
          if !(campaign.is_secret_ab) and campaign.campaign_control_percent != 0
            expRecord.push(total_delivery_count)
            expRecord.push(stat.experimental.delivery_count / total_delivery_count)
            expRecord.push($translate.instant('projectsReports.services.clientReportCsvCreator.hyouji_guruupu'))
          else
            expRecord.push(0)
            expRecord.push(0)
            expRecord.push('')
        expRecord.push(stat.experimental.delivery_count)
        expRecord.push(stat.experimental.conversion_rate)
        expRecord.push(stat.experimental.conversion_count)
        expRecord.push(applyCurrency(stat.experimental.average_conversion_price, currency))
        expRecord.push(applyCurrency(stat.experimental.conversion_price, currency))
        if project.product_line is 'zenclerk_lp'
          expRecord.push applyCurrency(campaign.cost_per_acquisition, currency)
        if isAb
          if !(campaign.is_secret_ab) and campaign.campaign_control_percent != 0
            if project.product_line is 'zenclerk_lp'
              expRecord.push stat.contribution_count
            expRecord.push stat.conversion_up_rate
            expRecord.push applyCurrency(stat.contribution_price, currency)
          else
            if project.product_line is 'zenclerk_lp'
              expRecord.push 0
            expRecord.push 0
            expRecord.push 0

        expRecord.push applyCurrency(stat.invoice_amount, currency)
        csvData.push expRecord

        if isAb and !(campaign.is_secret_ab) and campaign.campaign_control_percent != 0
          ctrRecord = [
            ''
            ''
            ''
            ''
            ''
            ''
            ''
            ''
            stat.control.delivery_count / total_delivery_count
            $translate.instant('projectsReports.services.clientReportCsvCreator.hihyouji_guruupu')
            stat.control.delivery_count
            stat.control.conversion_rate
            stat.control.conversion_count
            applyCurrency(stat.control.average_conversion_price, currency)
            applyCurrency(stat.control.conversion_price, currency)
            ''
            ''
            ''
          ]
          if project.product_line is 'zenclerk_lp'
            ctrRecord.push ''
            ctrRecord.push ''
          csvData.push ctrRecord

      resolve csvData



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.reports/client_report_csv_creator.service.coffee